var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDataHistogram(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.3333 6.97363C11.3333 5.31678 12.6765 3.97363 14.3333 3.97363H17.6667C19.3235 3.97363 20.6667 5.31678 20.6667 6.97363V9.33363H25C26.6569 9.33363 28 10.6768 28 12.3336V27.0003C28 27.5526 27.5523 28.0003 27 28.0003H5C4.44772 28.0003 4 27.5526 4 27.0003V16.3336C4 14.6768 5.34315 13.3336 7 13.3336H11.3333V6.97363ZM13.3333 26.0003H18.6667V6.97363C18.6667 6.42135 18.219 5.97363 17.6667 5.97363H14.3333C13.781 5.97363 13.3333 6.42135 13.3333 6.97363V26.0003ZM11.3333 15.3336H7C6.44772 15.3336 6 15.7813 6 16.3336V26.0003H11.3333V15.3336ZM20.6667 26.0003H26V12.3336C26 11.7813 25.5523 11.3336 25 11.3336H20.6667V26.0003Z",
    fill: "#131542"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDataHistogram);
export default __webpack_public_path__ + "static/media/DataHistogram.8747f7144a1741076c6d91099f17b25d.svg";
export { ForwardRef as ReactComponent };